export const isDev: boolean = process.env.NODE_ENV === 'development';
export const isTest: boolean = process.env.IS_TEST ? true : false;

export const config = {
  baseUrl: isDev ? 'http://local.particeep.com:9000' : '',
  basePath:  isDev ? '/' : '/app',
  dateFormat: 'dd/MM/yyyy',
  defaultCurrency: 'EUR',
  IMG_BASE_PATH: isDev ? (isTest ? "http://test-arkea-front.particeep.com/assets/images" : "http://local.particeep.com:9000/assets/images") : "/assets/images", 
  DOC_BASE_PATH: "/assets/doc",
  JS_BASE_PATH: "/assets/js"
};



// WEBPACK FOOTER //
// ./src/conf/config.ts